
export const IMPORTEXPORT_FORM = 'import-export';
export const FLORAFAUNA_FORM = 'flora-fauna';

export const Import_Export_Licence_Type = '1-44B-1';
export const Flora_Fauna_Licence_Type = '1-2PM1-0';

export const Import_Export_Licence_TypeName = 'Import Export';
export const Flora_Fauna_Licence_TypeName = 'Native Flora and Fauna Research';
